
<template>
  <div>
    <script :id="id" type="text/plain" :style="editorStyle"></script>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isMounted: false,
      editor: null
    };
  },
  props: {
    id: {
      type: String
    },
    editorStyle: {
      type: String,
      default: ""
    }
  },
  mounted() {
    let vm = this;
    vm.$nextTick(function() {
      let ue = new UE.ui.Editor({
        toolbars: [
          [
            "fullscreen", //全屏
            "undo", //撤销
            "redo", //重做
            "bold", //加粗
            "indent", //首行缩进
            "italic", //斜体
            "underline", //下划线
            "subscript", //下标
            "superscript", //上标
            "pasteplain", //纯文本粘贴模式
            "horizontal", //分隔线
            "rowspacingtop", //段前距
            "rowspacingbottom", //段后距
            "lineheight", //行间距
            "template", //模板
            "blockquote", //引用
            "fontfamily", //字体
            "fontsize", //字号
            "paragraph", //段落格式
            "spechars", //特殊字符
            "justifyleft", //居左对齐
            "justifyright", //居右对齐
            "justifycenter", //居中对齐
            "justifyjustify", //两端对齐
            "forecolor", //字体颜色
            "backcolor", //背景色
            "insertorderedlist", //有序列表
            "insertunorderedlist" //无序列表
          ]
        ],
        autoHeightEnabled: false,
        autoFloatEnabled: false
      });
      vm.editor = ue.render(vm.id);
    });
  },
  created() {},
  methods: {},
  destroy() {
    vm.editor.destroy();
  }
};
</script>


// WEBPACK FOOTER //
// src/commonplugin/uediter.vue